import { useSession } from "next-auth/react";

const useIsAdmin = () => {
  const { data: session } = useSession();
  return session?.user.isAdmin ?? false;
};

export default useIsAdmin;
